{
  "oneOf": [
    {
      "$ref": "https://schemas.gitbook.com/SiteAdaptiveDeterministicJSONSchemaPrimitives.json"
    },
    {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "object"
          ]
        },
        "description": {
          "type": "string"
        },
        "properties": {
          "type": "object",
          "additionalProperties": {
            "$ref": "https://schemas.gitbook.com/SiteAdaptiveDeterministicJSONSchemaClaimsProperties.json"
          }
        },
        "additionalProperties": {
          "type": "boolean",
          "enum": [
            false
          ]
        }
      },
      "required": [
        "type",
        "description",
        "properties",
        "additionalProperties"
      ],
      "additionalProperties": false
    }
  ],
  "$id": "https://schemas.gitbook.com/SiteAdaptiveDeterministicJSONSchemaClaimsProperties.json"
}